console.log('function');
const swiperMedia = new Swiper('#js-mediaSlide', {
  loop: true,
  speed: 8000,
  autoplay: {
    delay: 0,
    reverseDirection: true,
  },
  allowTouchMove: false,
  slidesPerView: 3,
  spaceBetween: 20,
  // Responsive breakpoints
  breakpoints: {
    989: {
      slidesPerView: 6,
      spaceBetween: 60,
    }
  },
})
